export default "__VITE_ASSET__DVdtrbAa__"